import * as React from 'react';

import {Card} from 'shells/card/card';
import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

import styles from './report-card-stack.module.css';

export function ReportLoadingCard() {
    return (
        <Card hasBorder={true} hasShadow={true} borderRadius={8}>
            <div className={styles['card-content']}>
                <div className='mr-16'>
                    <LoadingText height={32} width={32} />
                </div>
                <Stack spacing={4}>
                    <LoadingText height={20} width={200} />
                    <LoadingText width={75} />
                    <LoadingText width={100} />
                </Stack>
            </div>
        </Card>
    );
}
